import React from "react";
import {useConsumerSendMailMutation} from "../../Queries";
import {isValidEmail} from "../../components/Validations";
import {StyledButton, StyledOutlinedInput, StyledTypography} from "../../providers/layout/LayoutProvider";
import {makeStyles} from "@mui/styles";
import {useRecoilValue} from "recoil";
import {LocalizationsAtom} from "../../providers/localization/LocalizationProvider";

export const AccessForm = () => {
   const localizations = useRecoilValue(LocalizationsAtom);
   const [email, setEmail] = React.useState<string>('');
   const [sent, setSent] = React.useState<boolean>(false);

   const classes = useAccessFormStyles();
   const [sendMail] = useConsumerSendMailMutation();

   const onChange = (event: any) => {
      setEmail(event.target.value);
      setSent(false);
   }

   const onSend = async () => {
      const shopId = window.shopId || window.brandId;
      if (!!email && isValidEmail(email)) {
         await sendMail({
            variables: {
               shopId: shopId,
               mail: email
            }
         });
         setEmail('');
         setSent(true);
      }
   }

   return <>
      <form className={classes.lightBoxInputArea} onSubmit={async (e) => {
         e.preventDefault();
         await onSend();
      }}>
         <StyledOutlinedInput
            className={classes.input}
            id="email"
            type="text"
            value={email}
            onChange={onChange}
            placeholder={localizations.mainPageEnterEmail}
            aria-haspopup={false}
            autoComplete={"off"}
         />
         <StyledButton className={classes.button} styletype={"main"} onClick={onSend}
                       disabled={!email}>{localizations.mainPageSend}</StyledButton>
      </form>
      {sent && <div className={classes.emailSent}>
         <StyledTypography variant={"body1"} className={classes.emailSentDivider}
                           type={"main"}>{localizations.mainPageMailSent}</StyledTypography>
         <StyledTypography variant={"body1"} type={"main"}>{localizations.mainPageMailSent2}</StyledTypography>
      </div>}
   </>
}

const useAccessFormStyles = makeStyles({
   input: {
      width: '100%',
      height: '45px'
   },
   button: {
      height: '45px',
      minWidth: '150px'
   },
   lightBoxInputArea: {
      display: 'flex',
      alignItems: 'center',
      width: '100%'
   },
   lightBoxMaxWidth: {
      maxWidth: '60%',
      margin: '0 auto'
   },
   emailSent: {
      marginTop: '20px',
      textAlign: 'left',
      color: '#606060',
      padding: '20px',
      border: '1px solid #E0E0E0'
   },
   emailSentDivider: {
      marginBottom: '15px'
   },
});

